import React from 'react';
import CommentThread from '../../../../../shared/components/comments/CommentThread';

function mapDealComment(comment = {}) {
  return {
    ...comment,
    authorName: comment.authorName || comment.author || comment.autore || '',
    body: comment.body || comment.content || comment.text || comment.testo || '',
    createdAt: comment.createdAt || comment.date || comment.data || comment.timestamp || '',
    replies: (comment.replies || comment.risposte || []).map(mapDealComment),
  };
}

export default function DealCommentsSection({
  comments,
  autoFocus = false,
  commentsState = { status: 'idle', message: '' },
  onAddReply,
  onAddComment,
}) {
  return (
    <CommentThread
      autoFocus={autoFocus}
      title="Commenti"
      comments={(comments || []).map(mapDealComment)}
      isLoading={commentsState.status === 'loading'}
      error={commentsState.status === 'error' ? commentsState.message || 'Commenti non disponibili.' : ''}
      emptyLabel="Nessun commento"
      placeholder="Aggiungi un commento..."
      submitLabel="Aggiungi commento"
      onSubmitComment={onAddComment}
      onSubmitReply={onAddReply}
      allowReplies
      entityType="deal"
    />
  );
}
